import * as React from "react";

function Circle2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm72 384H184a23.98 23.98 0 0 1-22.39-15.38c-3.578-9.25-1.078-19.75 6.266-26.41l108.4-98.31c7.047-6.938 11.31-17 11.31-27.66s-4.266-20.72-12-28.31C259.4 172 232.9 172 216.6 187.9l-11 10.8c-9.5 9.4-25.5 9.2-33.9-.3-9.3-9.5-9.2-24.7.3-33.9l11-10.78c34.8-34.19 91.45-34.19 126.3 0 17 16.69 26.38 38.91 26.38 62.56s-9.375 45.88-26.38 62.56L246.2 336H328c13.25 0 24 10.75 24 24s-10.7 24-24 24z"
  }));
}

const ForwardRef = React.forwardRef(Circle2Icon);
export default ForwardRef;